module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 32
// module chunks = 0 1